import React, { memo } from "react";
import { Tooltip as AntTooltip } from "antd";
import type { TooltipProps as AntTooltipProps } from "antd";

const CustomTooltip: React.FC<AntTooltipProps> = ({ title, children, ...rest }) => (
  <AntTooltip title={title} {...rest}>
    {children}
  </AntTooltip>
);

export default memo(CustomTooltip);
